const messagesCommon = {
  en: {
    loading: '', // just a placeholder for empty
    call: 'Call',
    cancel: 'Cancel',
    join: 'Sign in',
    country: 'Country',
    search: 'Search',
    close: 'Close',
    next: 'Next',
    previous: 'Previous',
    select: 'Select',
    eur: '€',
    homepage: 'Home page',
    bookNow: 'Book Now',
    discoverMore: 'Discover more',
    until: 'until',
    learnMore: 'Learn more',
    localeSwitch: {
      buttonTitle: 'Switch Locale',
      title: 'Preferences',
      description: 'Please select your preferred language and currency.',
      selectLanguage: 'Select Language',
      selectCurrency: 'Select Currency',
      footer: 'All prices in currencies other than euros are approximate.',
      button: 'Update preferences',
    },
    accessCode: {
      label: 'Promo Code',
      placeholder: 'Enter Promo Code',
      confirm: 'Confirm',
      remove: 'Remove',
      invalidAccessCode: 'The entered promo code is not valid.',
      validAccessCode: 'The entered promo code is valid.',
    },
    bookingModal: {
      property: 'Property',
      hotelsResorts: 'Hotels and resorts',
      campsites: 'Campsites',
      date: 'Arrival & departure',
      guests: 'Guests',
      accessCode: 'Promo code',
      howMany: 'Select number of guests',
      adults: 'Adults',
      noChildren: 'Children',
      selectAge: 'Child age',
      selectBtn: 'Select',
      updateBtn: 'Search',
      closeBtn: 'Close',
      openBtn: 'Open',
      invalidAccessCode: 'Promo code not valid',
      accessCodeIsVoucher: 'Please enter a voucher code in second step of booking process',
      children: 'children',
      age: 'Child age',
      note: 'Accommodation price is shown per unit and is subject to change depending on the number of persons and additional services.',
      specialOffer: 'Only dates available for the special offer are shown on the calendar.',
      datesChanged: 'Dates changed based on availability.',
      accessCodeRemoved: 'Promo code was removed because it is not valid for this property.',
      guestsAdjusted: 'Guest number adjusted due to property limits.',
      changeDates: 'Change dates',
      datesUnavailable: 'No Accomodation Available for Selected Dates',
      datesUnavailableContent: 'Unfortunately, no accomodation is available for selected dates at {property}. Would you like to change your booking dates to the next available ones: <span>{dates}</span>?',
      datesUnavailableForAccessCode: 'Promo Code Not Valid for Your Dates',
      datesUnavailableForAccessCodeContent: 'Unfortunately, promo code is not valid for the selected dates. Would you like to change your booking dates to <span>{dates}</span> so that you can use the promo code?',
      unavailable: 'Unavailable',
      checkoutOnly: 'Checkout only',
    },
    maiFamilyBanner: {
      description: 'As a member of MaiFamily, you can choose from a selection of offers available only to our employees.',
    },
    loyaltyBanner: {
      title: 'With gratitude, from your first stay',
      button: 'Become a member',
      membershipDiscount: 'membership discount',
      becomeMember: 'Become a member',
      description: 'Become a MaiStar Rewards Club member and save up to 20%. It’s easy to join using your personal information while booking your stay.',
      alreadyMember: 'Already a member?',
      signIn: 'Sign in',
      maistarPricesApplied: 'MaiStar prices applied',
      applyMaistarPrices: 'Apply MaiStar prices',
    },
    loyaltySplit: {
      title: 'Welcome to MaiStar Rewards Club',
      accessAccount: 'Access your account',
      signInText: 'Sign in to your account and enjoy all the  benefits of the MaiStar Rewards Program.',
      signIn: 'Sign in',
      newHere: 'New here?',
      joinText: 'Join for free and unlock exclusive benefits of the MaiStar Rewards Program.',
      register: 'Register now',
      accessText: 'As a MaiStar Rewards Club member, you’ll have access to:',
      benefits: '<li>My Profile & Preferences</li><li>My Points</li><li>My Bookings</li><li>My Rewards</li><li>Get up to 20% off bookings, collect points, and enjoy exclusive rewards</li>',
    },
    unitDemand: {
      availabilityError: 'Availability could not be determined',
      contactText: 'Sorry, there are no available units for the selected dates.',
      contactButton: 'Contact us',
      modifySearch: 'Modify search',
    },
    authStatus: {
      dashboard: 'Overview',
      myBookings: 'My bookings',
      pointsActivity: 'Points activity',
      MaiStarRewards: 'MaiStar rewards',
      myProfile: 'My profile',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      login: 'Login',
      logout: 'Logout',
    },
    loyaltyProfile: {
      profileLocales: {
        l1050: 'Croatian',
        l1040: 'Italian',
        l1033: 'English',
        l1031: 'German',
        l1060: 'Slovenian',
        l1045: 'Polish',
        l2067: 'Dutch',
      },
      profileTitle: {
        mr: 'Mr.',
        mrs: 'Mrs.',
      },
      identity: 'Identity',
      title: 'Title',
      firstName: 'First name',
      lastName: 'Last name',
      dob: 'Date of birth',
      locale: 'Language',
      contact: 'Contact',
      email: 'Email',
      address: 'Address',
      postalCode: 'Postal Code',
      city: 'City',
      phoneNumber: 'Phone Number',
      updateSuccess: 'You successfully updated your profile.',
      isMaiFamily: 'I am a part of Adris group.',
      corporateCardNumber: 'Corporate card number',
      companyName: 'Company name',
      maiFamilyNote: '<p>Employees are not eligible to earn or redeem points in this loyalty program. Employees are instead entitled to preferential rates through the MaiFamily program upon registering their company details.</p><p>To update your company name or corporate card number, contact Loyalty Customer Care at <a href="mailto:loyalty@maistra.hr">loyalty@maistra.hr</a>. You’ll receive a response within 48 hours.</p>',
    },
    formValidation: {
      required: 'This field is required.',
      email: '<span>Enter a valid e-mail. Please use a format like name&#64;example.com.</span>',
      min: 'This field must be at least',
      maxPoints: 'The selected amount is not available.',
      eq: 'This field must have',
      digits: 'digits',
      characters: 'characters',
      size: 'Maximum file size is',
      phone: 'Enter a valid phone number with a prefix (+ or 00). Please use a format like +49 2 545 8654.',
      reqAtLeastOne: 'You need to select at least one option.',
      number: 'Enter a valid number.',
      reqNumber: 'You need to enter a valid number.',
      reqFile: 'You need to select a file to upload.',
      notVerifiedMail: 'Please check and verify your email again.',
      ccard: 'The card number you have entered is invalid.',
      cvv: 'Please enter a valid CVV number. Should be 3 digits.',
      cvv34: 'Please enter a valid CVV number. Should be 3 or 4 digits.',
      onePositive: 'One of the fields must be a positive number',
      birthdate: 'The entered birthdate is not valid.',
    },
    notification: {
      success: 'Successfully submitted.',
      error: 'Error while submitting.',
      moreInfo: 'More info',
    },
    fatalError: {
      title: 'We\'re sorry, but something went wrong.',
      message: 'Please go back to home page and try again.',
      button: 'Back To Homepage',
      code: {
        propertyIdMissing: 'You arrived to this page without selected property.',
        unitOrRateMissing: 'You arrived to this page without selecting unit or rate.',
        phobsError10001: 'Request limit to external booking service reached',
        phobsError5008: 'There is no availability for the selected unit. Please try again with a different unit.',
        validationError: 'Error validating your entered data. Please review your personal details and try again.',
      },
    },
    myProfile: {
      title: 'My Profile',
      changeEmailText: 'To change your e-mail, please contact our',
      changeEmailCC: 'Customer Care',
      newsletter: 'As a member of the MaiStar Rewards Club, you will receive news, special offers, and exclusive deals reserved exclusively for MaiStar Rewards Club programme members.',
      requiredFields: 'These fields are required.',
      dataProtection: '<p>We respect your privacy and are committed to protecting your personal data. We collect different types of personal data about you, depending on your relationship with us and the services you use. In any case, we collect and process your personal data for legitimate purposes and on a valid legal basis.</p><p>For more information about the protection of your personal data, please see our <a href="#">Privacy Notice</a>.</p>',
    },
  },
  de: {
    loading: '', // Platzhalter
    call: 'Anruf',
    cancel: 'Stornieren',
    join: 'Beitreten',
    country: 'Land',
    search: 'Suche',
    close: 'Schließen',
    next: 'Nächste',
    previous: 'Vorige',
    select: 'Auswählen',
    eur: '€',
    homepage: 'Homepage',
    bookNow: 'Jetzt buchen',
    discoverMore: 'Mehr entdecken',
    until: 'bis',
    learnMore: 'Mehr entdecken',
    localeSwitch: {
      buttonTitle: 'Gebietsschema schalten',
      title: 'Einstellungen',
      description: 'Bitte wählen Sie Ihre bevorzugte Sprache und Währung aus',
      selectLanguage: 'Sprache auswählen',
      selectCurrency: 'Währung auswählen',
      footer: 'Preisangaben in anderen währungen als euro sind lediglich richtwerte.',
      button: 'Einstellungen aktualisieren',
    },
    accessCode: {
      label: 'Gutscheincode',
      placeholder: 'Gutscheincode',
      confirm: 'Bestätigen',
      remove: 'Entfernen',
      invalidAccessCode: 'Der eingegebene Gutscheincode ist ungültig.',
      validAccessCode: 'Der eingegebene Gutscheincode ist gültig.',
    },
    bookingModal: {
      property: 'Objekt',
      hotelsResorts: 'Hotels und Resorts',
      campsites: 'Campingplätze',
      date: 'Ankunft und Abreise',
      guests: 'Gäste',
      accessCode: 'Gutscheincode',
      howMany: 'Wie viele Gäste werden übernachten?',
      adults: 'Erwachsene',
      noChildren: 'Kinder',
      selectAge: 'Kind',
      selectBtn: 'Auswählen',
      updateBtn: 'Suche aktualisieren',
      closeBtn: 'Schließen',
      openBtn: 'Öffnen',
      invalidAccessCode: 'Gutscheincode ist ungültig',
      accessCodeIsVoucher: 'Bitte geben Sie im zweiten Schritt des Buchungsvorgangs einen Gutschein-Code ein',
      children: 'Kinder',
      age: 'Alter des Kindes',
      note: 'Die Preise für die Unterkunft werden pro Einheit angegeben und können sich abhängig von der Personenzahl und den Zusatzleistungen ändern.',
      specialOffer: 'Nur die für das Sonderangebot verfügbaren Termine werden im Kalender angezeigt.',
      datesChanged: 'Die Termine wurden aufgrund der Verfügbarkeit geändert.',
      accessCodeRemoved: 'Der Promo-Code wurde entfernt, da er für diese Unterkunft nicht gültig ist.',
      guestsAdjusted: 'Die Anzahl der Gäste wurde aufgrund von Beschränkungen der Unterkunft angepasst.',
      changeDates: 'Daten ändern',
      datesUnavailable: 'Keine Unterkunft für den ausgewählten Zeitraum verfügbar',
      datesUnavailableContent: 'Leider ist für den ausgewählten Zeitraum keine Unterkunft verfügbar {property}. Möchten Sie Ihre Buchungsdaten auf den nächsten verfügbaren Zeitraum ändern: <span>{dates}</span>?',
      datesUnavailableForAccessCode: 'Der Aktionscode ist für den von Ihnen ausgewählten Zeitraum nicht gültig',
      datesUnavailableForAccessCodeContent: 'Der Aktionscode ist für den von Ihnen ausgewählten Zeitraum leider nicht gültig. Möchten Sie Ihre Buchungsdaten so <span>{dates}</span> ändern, damit Sie den Aktionscode verwenden können?',
      unavailable: 'Nicht verfügbar',
      checkoutOnly: 'Nur Abreise',
    },
    maiFamilyBanner: {
      description: 'Als Mitglied der MaiFamily können Sie du aus einer Vielzahl exklusiver Angebote für unsere Mitarbeiter wählen.',
    },
    loyaltyBanner: {
      title: 'Als kleines Dankeschön für Ihren ersten Aufenthalt',
      button: 'Mitglied werden',
      membershipDiscount: 'Mitgliederrabatt',
      becomeMember: 'Mitglied werden',
      description: 'Werden Sie Mitglied im MaiStar Rewards Club und sparen Sie bis zu 20 %. Sie können ihm mit Ihren persönlichen Daten ganz einfach beitreten, während Sie Ihren Aufenthalt buchen.',
      alreadyMember: 'Bereits Mitglied?',
      signIn: 'Anmelden',
      maistarPricesApplied: 'MaiStar-Preise angewendet',
      applyMaistarPrices: 'MaiStar-Preise anwenden',
    },
    loyaltySplit: {
      title: 'Willkommen im MaiStar Rewards Club',
      accessAccount: 'Zugriff auf Ihr Konto',
      signInText: 'Melden Sie sich bei Ihrem Konto an und profitieren Sie von allen Vorteilen des MaiStar Rewards-Programms.',
      signIn: 'Anmelden',
      newHere: 'Zum ersten Mal hier?',
      joinText: 'Kostenlos anmelden und exklusive Vorteile des MaiStar Rewards-Programms nutzen.',
      register: 'Jetzt registrieren',
      accessText: 'Eine Mitgliedschaft bei dem MaiStar Rewards Club gibt Ihnen Einsicht in:',
      benefits: '<li>Mein Profil & Präferenzen</li><li>Meine Punkte</li><li>Meine Buchungen</li><li>Meine Auszeichnungen</li><li>Erhalten Sie bis zu 20 % Rabatt auf Buchungen, sammeln Sie Punkte und nutzen exklusive Auszeichnungen</li>',
    },
    unitDemand: {
      availabilityError: 'Die Verfügbarkeit konnte nicht ermittelt werden',
      contactText: 'Leider sind keine Einheiten für den gewünschten Zeitraum verfügbar.',
      contactButton: 'Kontaktieren Sie uns',
      modifySearch: 'Suche bearbeiten',
    },
    authStatus: {
      dashboard: 'Dashboard',
      myBookings: 'Meine Buchungen',
      pointsActivity: 'Aktivierte Punkte',
      MaiStarRewards: 'MaiStar Preise',
      myProfile: 'Mein Profil',
      openMenu: 'Menü öffnen',
      closeMenu: 'Menü schließen',
      login: 'Anmelden',
      logout: 'Auschecken',
    },
    loyaltyProfile: {
      profileLocales: {
        l1050: 'Kroatisch',
        l1040: 'Italienisch',
        l1033: 'Englisch',
        l1031: 'Deutsch',
        l1060: 'Slowenisch',
        l1045: 'Polnisch',
        l2067: 'Niederländisch',
      },
      profileTitle: {
        mr: 'Herr',
        mrs: 'Frau',
      },
      identity: 'Persönliche Daten',
      title: 'Anrede',
      firstName: 'Vorname',
      lastName: 'Nachname',
      dob: 'Geburtsdatum',
      locale: 'Sprache',
      contact: 'Kontakt',
      email: 'E-Mail',
      address: 'Adresse',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      phoneNumber: 'Telefonnummer',
      updateSuccess: 'Sie haben Ihr Profil erfolgreich aktualisiert.',
      isMaiFamily: 'Ich bin Mitglied der Adris Gruppe.',
      corporateCardNumber: 'Firmenkartennummer',
      companyName: 'Firmenname',
      maiFamilyNote: '<p>Mitarbeiter/-innen sind in diesem Treueprogramm nicht zum Sammeln oder Einlösen von Punkten berechtigt. Stattdessen erhalten sie nach Angabe ihrer Unternehmensdaten im Rahmen des MaiFamily-Programms Vorzugskonditionen.</p><p>Um Ihren Firmennamen oder Ihre Firmenkartennummer zu aktualisieren, kontaktieren Sie den Loyalty-Kundenservice unter <a href="mailto:loyalty@maistra.hr">loyalty@maistra.hr</a>. Sie erhalten innerhalb von 48 Stunden eine Antwort.</p>',
    },
    formValidation: {
      required: 'Dieses Feld ist erforderlich.',
      email: '<span>Geben Sie eine gültige E-Mail-Adresse ein. Bitte verwenden Sie ein Format wie name&#64;example.com.</span>',
      min: 'Dieses Feld muss mindestens enthalten',
      maxPoints: 'Der ausgewählte Betrag ist nicht verfügbar.',
      eq: 'Dieses Feld muss enthalten',
      digits: 'Ziffern',
      characters: 'Zeichen',
      size: 'Die maximale Dateigröße ist',
      phone: 'Geben Sie eine gültige Telefonnummer mit Vorwahl (+ oder 00) ein. Bitte verwenden Sie ein Format wie +49 2 545 8654.',
      reqAtLeastOne: 'Sie müssen mindestens eine Option auswählen.',
      number: 'Geben Sie eine gültige Nummer ein.',
      reqNumber: 'Sie müssen eine gültige Nummer eingeben.',
      reqFile: 'Sie müssen eine Datei zum Hochladen auswählen.',
      notVerifiedMail: 'Bitte prüfen und bestätigen Sie Ihre E-Mail.',
      ccard: 'Die eingegebene Kartennummer ist ungültig.',
      cvv: 'Bitte geben Sie eine gültige CVV-Nummer ein. Die Nummer muss 3 Ziffern enthalten.',
      cvv34: 'Bitte geben Sie eine gültige CVV-Nummer ein. Die Nummer muss 3 oder 4 Ziffern enthalten.',
      onePositive: 'Eines der Felder muss eine positive Zahl sein',
      birthdate: 'Die eingegebene Geburtsdatum ist ungültig.',
    },
    notification: {
      success: 'Erfolgreich versendet.',
      error: 'Beim Senden ist ein Fehler aufgetreten.',
      moreInfo: 'Mehr Informationen',
    },
    fatalError: {
      title: 'Entschuldigung, ein Fehler ist aufgetreten.',
      message: 'Gehen Sie zurück zur Startseite und versuchen Sie es erneut.',
      button: 'Zurück zur Startseite',
      code: {
        propertyIdMissing: 'Sie sind auf diese Seite gelangt, ohne ein Objekt auszuwählen.',
        unitOrRateMissing: 'Sie sind auf dieser Seite angekommen, ohne eine Einheit oder einen Preis auszuwählen.',
        phobsError10001: 'Sie haben das Anforderungslimit für den externen Buchungsservice erreicht',
        phobsError5008: 'Die ausgewählte Einheit ist nicht verfügbar. Bitte versuchen Sie es erneut mit einer anderen Einheit.',
        validationError: 'Fehler beim Validieren Ihrer eingegebenen Daten. Bitte überprüfen Sie Ihre personenbezogenen Daten und versuchen Sie es erneut.',
      },
    },
    myProfile: {
      title: 'Mein Profil',
      changeEmailText: 'Um Ihre E-Mail zu ändern, wenden Sie sich bitte an',
      changeEmailCC: 'Kundendienst',
      newsletter: 'Als Mitglied des MaiStar Rewards Clubs erhalten Sie Neuigkeiten, Sonderangebote und exklusive Vorteile, die ausschließlich den Mitgliedern des MaiStar Rewards Club-Programms vorbehalten sind.',
      requiredFields: 'Diese Felder sind Pflichtfelder.',
      dataProtection: '<p>Wir respektieren Ihre Privatsphäre und verpflichten uns, Ihre personenbezogenen Daten zu schützen. Wir erheben verschiedene Arten von personenbezogenen Daten über Sie, abhängig von Ihrer Beziehung zu uns und den von Ihnen genutzten Leistungen. Wir erheben und verarbeiten Ihre personenbezogenen Daten für legitime Zwecke und auf einer gültigen Rechtsgrundlage.</p><p>Weitere Informationen zum Schutz Ihrer personenbezogenen Daten finden Sie in unserer <a href="#"> Datenschutzerklärung</a>.</p>',
    },
  },
  hr: {
    loading: '', // zamjenski znak za prazno polje
    call: 'Nazovi',
    cancel: 'Otkaži',
    join: 'Pridruži se',
    country: 'Država',
    search: 'Pretraži',
    close: 'Zatvori',
    next: 'Sljedeće',
    previous: 'Prethodno',
    select: 'Odaberi',
    eur: '€',
    homepage: 'Home page',
    bookNow: 'Rezerviraj sada',
    discoverMore: 'Otkrijte više',
    until: 'do',
    learnMore: 'Otkrijte više',
    localeSwitch: {
      buttonTitle: 'Prebacite lokalitet',
      title: 'Preferencije',
      description: 'Odaberite jezik i valutu koji vam odgovaraju',
      selectLanguage: 'Odabir jezika',
      selectCurrency: 'Odabir valute',
      footer: 'Cijene izražene u svim valutama, osim u eurima su informativnog karaktera.',
      button: 'Ažuriraj preferencije',
    },
    accessCode: {
      label: 'Promotivni kod',
      placeholder: 'Unesite promotivni kod',
      confirm: 'Potvrdi',
      remove: 'Ukloni',
      invalidAccessCode: 'Uneseni promotivni kod nije valjan.',
      validAccessCode: 'Uneseni promotivni kod je valjan.',
    },
    bookingModal: {
      property: 'Objekt',
      hotelsResorts: 'Hoteli i resorti',
      campsites: 'Kampovi',
      date: 'Dolazak i odlazak',
      guests: 'Gosti',
      accessCode: 'Promotivni kod',
      howMany: 'Koliko će gostiju boraviti?',
      adults: 'Odrasli',
      noChildren: 'Djeca',
      selectAge: 'Dijete',
      selectBtn: 'Odaberi',
      updateBtn: 'Ažuriraj pretragu',
      closeBtn: 'Zatvori',
      openBtn: 'Otvori',
      invalidAccessCode: 'Promotivni kod nije valjan',
      accessCodeIsVoucher: 'Unesite vaučer kod u drugom koraku procesa rezervacije',
      children: 'djeca',
      age: 'Dob djeteta',
      note: 'Cijene smještaja iskazane su po jedinici te su podložne promjeni ovisno o broju osoba i dodatnim uslugama.',
      specialOffer: 'Na kalendaru su prikazani samo datumi koji su dostupni za posebnu ponudu.',
      datesChanged: 'Datumi su promijenjeni zbog dostupnosti.',
      accessCodeRemoved: 'Promotivni kod je uklonjen jer nije važeći za ovaj objekt.',
      guestsAdjusted: 'Broj gostiju prilagođen zbog ograničenja objekta.',
      changeDates: 'Promijeni datume',
      datesUnavailable: 'Za odabrane datume nije dostupna nijedna smještajna jedinica',
      datesUnavailableContent: 'Nažalost, za odabrane datume nije dostupna nijedna smještajna jedinica u {property}. Želite li promijeniti datume rezervacije u sljedeće dostupne datume: <span>{dates}</span>?',
      datesUnavailableForAccessCode: 'Promotivni kod ne vrijedi za vaše datume',
      datesUnavailableForAccessCodeContent: 'Nažalost, promotivni kod ne vrijedi za odabrane datume. Želite li promijeniti datume rezervacije u <span>{dates}</span> kako biste mogli iskoristiti promotivni kod?',
      unavailable: 'Nedostupno',
      checkoutOnly: 'Samo odjava',
    },
    maiFamilyBanner: {
      description: 'Kao član programa MaiFamily možete birati između ponuda dostupnih isključivo našim zaposlenicima.',
    },
    loyaltyBanner: {
      title: 'Zahvalni smo od vašeg prvog boravka',
      button: 'Postanite članom',
      membershipDiscount: 'popust za članove',
      becomeMember: 'Postanite članom',
      description: 'Postanite članom programa MaiStar Rewards Club i uštedite do 20 %. Lako se možete pridružiti s pomoću osobnih podataka tijekom rezerviranja smještaja.',
      alreadyMember: 'Već ste član?',
      signIn: 'Prijavite se',
      maistarPricesApplied: 'Primijenjene cijene MaiStar',
      applyMaistarPrices: 'Primijeni MaiStar cijene',
    },
    loyaltySplit: {
      title: 'Dobrodošli u MaiStar Rewards Club',
      accessAccount: 'Pristupite svom računu',
      signInText: 'Prijavite se u svoj račun i uživajte u pogodnostima MaiStar Rewards Programa.',
      signIn: 'Prijavite se',
      newHere: 'Novi ste ovdje?',
      joinText: 'Pridružite se besplatno i otključajte ekskluzivne pogodnosti MaiStar Rewards Programa.',
      register: 'Registrirajte se sada',
      accessText: 'Članstvom u MaiStar Rewards Clubu imati ćete uvid u:',
      benefits: '<li>Moj Profil & Preferencije</li><li>Moji Bodovi</li><li>Moje Rezervacije</li><li>Moje Nagrade</li><li>Ostvarite do 20% popusta na rezervacije, sakupljajte bodove i koristite ekskluzivne nagrade</li>',
    },
    unitDemand: {
      availabilityError: 'Raspoloživost nije bilo moguće utvrditi',
      contactText: 'Nažalost nema raspoloživih jedinica u traženom periodu.',
      contactButton: 'Obratite nam se',
      modifySearch: 'Izmijeni pretragu',
    },
    authStatus: {
      dashboard: 'Prikaz',
      myBookings: 'Moje rezervacije',
      pointsActivity: 'Aktivirani bodovi',
      MaiStarRewards: 'MaiStar Rewards',
      myProfile: 'Moj profil',
      openMenu: 'Otvori izbornik',
      closeMenu: 'Zatvori izbornik',
      login: 'Prijava',
      logout: 'Odjava',
    },
    loyaltyProfile: {
      profileLocales: {
        l1050: 'Hrvatski',
        l1040: 'Talijanski',
        l1033: 'Engleski',
        l1031: 'Njemački',
        l1060: 'Slovenski',
        l1045: 'Poljski',
        l2067: 'Nizozemski',
      },
      profileTitle: {
        mr: 'Gospodin',
        mrs: 'Gospođa',
      },
      identity: 'Osobni podaci',
      title: 'Titula',
      firstName: 'Ime',
      lastName: 'Prezime',
      dob: 'Datum rođenja',
      locale: 'Jezik',
      contact: 'Kontakt',
      email: 'E-pošta',
      address: 'Adresa',
      postalCode: 'Poštanski broj',
      city: 'Grad',
      phoneNumber: 'Broj telefona',
      updateSuccess: 'Uspješno ste ažurirali svoj profil.',
      isMaiFamily: 'Dio sam Adris grupe.',
      corporateCardNumber: 'Broj poslovne kartice',
      companyName: 'Naziv društva',
      maiFamilyNote: '<p>Zaposlenici nemaju pravo na sakupljanje ni iskorištavanje bodova u ovom programu vjernosti. Zaposlenicima su umjesto toga dostupne povlaštene cijene kroz program MaiFamily nakon registracije podataka o društvu.</p><p>Da biste ažurirali naziv društva ili broj poslovne kartice, obratite se korisničkoj službi programa vjernosti na <a href="mailto:loyalty@maistra.hr">loyalty@maistra.hr</a>. Dobit ćete odgovor u roku od 48 sati.</p>',
    },
    formValidation: {
      required: 'Ovo polje je obavezno.',
      email: '<span>Unesite valjanu adresu e-pošte. Upotrijebite format kao što je ime&#64;primjer.com.</span>',
      min: 'Ovo polje mora sadržavati najmanje',
      max: 'Ovo polje mora sadržavati najviše',
      maxPoints: 'Odabrani iznos nije dostupan.',
      eq: 'Ovo polje mora sadržavati',
      digits: 'znamenka',
      characters: 'znakovi',
      size: 'Maksimalna veličina datoteke je',
      phone: 'Unesite valjani telefonski broj s prefiksom (+ ili 00). Upotrijebite format kao što je +385 97 545 8654.',
      reqAtLeastOne: 'Morate odabrati najmanje jednu opciju.',
      number: 'Unesite valjani broj.',
      reqNumber: 'Trebate unijeti valjani broj.',
      reqFile: 'Morate odabrati datoteku za prijenos.',
      notVerifiedMail: 'Provjerite i ponovno potvrdite svoju e-poštu.',
      ccard: 'Broj kartice koji ste unijeli nije važeći.',
      cvv: 'Unesite važeći CVV broj. Broj treba sadržavati 3 znamenke.',
      cvv34: 'Unesite važeći CVV broj. Broj treba sadržavati 3 ili 4 znamenke.',
      onePositive: 'Jedno od polja mora biti pozitivan broj',
      birthdate: 'Uneseni datum rođenja nije ispravan.',
    },
    notification: {
      success: 'Uspješno poslano.',
      error: 'Došlo je do pogreške prilikom slanja.',
      moreInfo: 'Više informacija',
    },
    fatalError: {
      title: 'Žao nam je, došlo je do pogreške.',
      message: 'Vratite se natrag na početnu stranicu i pokušajte ponovno.',
      button: 'Natrag na početnu stranicu',
      code: {
        propertyIdMissing: 'Došli ste na ovu stranicu bez da ste odabrali objekt.',
        unitOrRateMissing: 'Došli ste na ovu stranicu bez odabira jedinice ili cijene.',
        phobsError10001: 'Dosegnuli ste ograničenje zahtjeva za vanjsku uslugu rezerviranja',
        phobsError5008: 'Odabrana jedinica nije dostupna. Pokušajte ponovno s drugom jedinicom.',
        validationError: 'Došlo je do pogreške pri potvrđivanju unesenih podataka. Pregledajte svoje osobne podatke i pokušajte ponovno.',
      },
    },
    myProfile: {
      title: 'Moj profil',
      changeEmailText: 'Da biste promijenili svoju e-poštu, obratite se',
      changeEmailCC: 'Služba za korisnike',
      newsletter: 'Kao član programa MaiStar Rewards Club, primat ćete novosti, posebne ponude i ekskluzivne pogodnosti dostupne samo članovima MaiStar Rewards Club programa.',
      requiredFields: 'Ova su polja obavezna.',
      dataProtection: '<p>Poštujemo vašu privatnost i obvezujemo se na zaštitu vaših osobnih podataka. Prikupljamo različite vrste vaših osobnih podataka ovisno o odnosu koji imate s nama i uslugama koje upotrebljavate. U svakom slučaju vaše osobne podatke prikupljamo i obrađujemo sa svrhom i prema zakonu.</p><p>Više informacija o zaštiti osobnih podataka potražite u našoj <a href="#">Izjavi o privatnosti</a>.</p>',
    },
  },
  it: {
    loading: 'Caricamento in corso...',
    call: 'Chiamata',
    cancel: 'Annulla',
    join: 'Unisciti',
    country: 'Paese',
    search: 'Ricerca',
    close: 'Chiudi',
    next: 'Successivo',
    previous: 'Precedente',
    select: 'Seleziona',
    eur: '€',
    homepage: 'Home page',
    bookNow: 'Prenota ora',
    discoverMore: 'Scopri di più',
    until: 'fino a',
    learnMore: 'Maggiori informazioni',
    localeSwitch: {
      buttonTitle: 'switchLocale',
      title: 'Preferenze',
      description: 'Si prega di selezionare la lingua e la valuta preferite',
      selectLanguage: 'Seleziona lingua',
      selectCurrency: 'Seleziona valuta',
      footer: 'I prezzi indicati in tutte le altre valute tranne euro sono informativi.',
      button: 'Aggiorna preferenze',
    },
    accessCode: {
      label: "Codice d'accesso",
      placeholder: 'Inserisci il codice promozionale',
      confirm: 'Conferma',
      remove: 'Rimuovi',
      invalidAccessCode: 'Il codice promozionale inserito non è valido.',
      validAccessCode: 'Il codice promozionale inserito è valido.',
    },
    bookingModal: {
      property: 'Struttura',
      hotelsResorts: 'Hotel e resort',
      campsites: 'Campeggi',
      date: 'Arrivo e partenza',
      guests: 'Ospiti',
      accessCode: 'Codice promozionale',
      howMany: 'Quanti ospiti vi alloggeranno?',
      adults: 'Adulto',
      noChildren: 'Bambini',
      selectAge: 'Bambino',
      selectBtn: 'Seleziona',
      updateBtn: 'Aggiorna ricerca',
      closeBtn: 'Chiudi',
      openBtn: 'Apri',
      invalidAccessCode: 'Codice promozionale non valido',
      accessCodeIsVoucher: 'Inserite un codice voucher nel secondo passaggio del processo di prenotazione',
      children: 'bambini',
      age: 'Età del bambino',
      note: 'I prezzi degli alloggi si intendono per singola unità e sono soggetti a variazioni in base al numero di persone e servizi supplementari.',
      specialOffer: 'Nel calendario vengono mostrate solo le date disponibili per l\'offerta speciale.',
      datesChanged: 'Le date sono cambiate in base alla disponibilità.',
      accessCodeRemoved: 'Il codice promozionale è stato rimosso perché non valido per questa struttura.',
      guestsAdjusted: 'Numero degli ospiti modificato in base ai limiti della struttura.',
      changeDates: 'Modifica le date',
      datesUnavailable: 'Nessuna sistemazione disponibile per le date selezionate',
      datesUnavailableContent: 'Purtroppo non è disponibile alcuna sistemazione per le date selezionate presso {property}. Vorrebbe modificare le date della Sua prenotazione con le prossime disponibili: <span>{dates}</span>?',
      datesUnavailableForAccessCode: 'Il codice promozionale non è valido per le date selezionate',
      datesUnavailableForAccessCodeContent: 'Purtroppo il codice promozionale non è valido per le date selezionate. Desidera modificare le date della Sua prenotazione <span>{dates}</span> per poter utilizzare il codice promozionale?',
      unavailable: 'Non disponibile',
      checkoutOnly: 'Solo checkout',
    },
    maiFamilyBanner: {
      description: 'Partecipando al programma MaiFamily puoi scegliere tra le diverse offerte disponibili esclusivamente per i nostri dipendenti.',
    },
    loyaltyBanner: {
      title: 'Con gratitudine, dal Suo primo soggiorno',
      button: 'Diventa affiliato',
      membershipDiscount: 'sconto affiliato',
      becomeMember: 'Diventa affiliato',
      description: 'Diventi affiliato del programma MaiStar Rewards Club e risparmi fino al 20%. Si può unire a noi, semplicemente, utilizzando i Suoi dati personali, mentre prenota il Suo soggiorno.',
      alreadyMember: 'Già membro?',
      signIn: 'Accedi',
      maistarPricesApplied: 'Prezzi MaiStar applicati',
      applyMaistarPrices: 'Applica prezzi MaiStar',
    },
    loyaltySplit: {
      title: 'Benvenuti nel MaiStar Rewards Club',
      accessAccount: 'Accedi al tuo account',
      signInText: 'Accedi al tuo account e godi di tutti i vantaggi del Programma Fedeltà MaiStar.',
      signIn: 'Accedi',
      newHere: 'Prima volta qui?',
      joinText: 'Iscriviti gratuitamente e scopri i vantaggi esclusivi del Programma Fedeltà MaiStar.',
      register: 'Registrati ora',
      accessText: 'Con l’affiliazione al MaiStar Rewards Club potrete visualizzare:',
      benefits: '<li>Il Mio Profilo e le Preferenze</li><li>I Miei Punti</li><li>Le Mie Prenotazioni</li><li>I Miei Premi</li><li>Ottenete fino al 20% di sconto sulle prenotazioni, accumulate i punti e approfittate di premi esclusivi</li>',
    },
    unitDemand: {
      availabilityError: 'Non è stato possibile determinare la disponibilità',
      modifySearch: 'Modifica ricerca',
      contactText: 'Non ci sono unità disponibili per le date selezionate.',
      contactButton: 'Contattaci',
    },
    authStatus: {
      dashboard: 'Riepilogo',
      myBookings: 'Le mie prenotazioni',
      pointsActivity: 'Attività a punti',
      MaiStarRewards: 'Premi MaiStar',
      myProfile: 'Il mio profilo',
      openMenu: 'Apri menu',
      closeMenu: 'Chiudi menu',
      login: 'Accedi',
      logout: 'Esci',
    },
    loyaltyProfile: {
      profileLocales: {
        l1050: 'Croato',
        l1040: 'Italiano',
        l1033: 'Inglese',
        l1031: 'Tedesco',
        l1060: 'Sloveno',
        l1045: 'Polacco',
        l2067: 'Olandese',
      },
      profileTitle: {
        mr: 'Sig.',
        mrs: 'Sig.ra',
      },
      identity: 'Dati personali',
      title: 'Titolo',
      firstName: 'Nome',
      lastName: 'Cognome',
      dob: 'Data di nascita',
      locale: 'Lingua',
      contact: 'Contatto',
      email: 'E-mail',
      address: 'Indirizzo',
      postalCode: 'Codice Postale',
      city: 'Città',
      phoneNumber: 'Numero di telefono',
      updateSuccess: 'Ha aggiornato correttamente il Suo profilo.',
      isMaiFamily: 'Faccio parte del gruppo Adris.',
      corporateCardNumber: 'Numero della carta aziendale',
      companyName: 'Nome dell’azienda',
      maiFamilyNote: '<p>I dipendenti non sono autorizzati a raccogliere o convertire punti nel presente programma fedeltà. I dipendenti hanno invece diritto a tariffe agevolate attraverso il programma MaiFamily previa registrazione dei dati aziendali.</p><p>Per aggiornare il nome della vostra azienda o il numero della carta aziendale, contattate il Servizio clienti Loyalty all’indirizzo <a href="mailto:loyalty@maistra.hr">loyalty@maistra.hr</a>. Riceverete una risposta entro 48 ore.</p>',
    },
    formValidation: {
      required: 'Questo campo è obbligatorio.',
      email: '<span>Inserisci un indirizzo e-mail valido. Utilizza un formato come nome&#64;esempio.com.</span>',
      min: 'Questo campo deve contenere almeno',
      maxPoints: 'L’importo selezionato non è disponibile.',
      eq: 'Questo campo deve contenere',
      digits: 'cifre',
      characters: 'caratteri',
      size: 'La dimensione massima del file è',
      phone: 'Inserisci un numero di telefono valido con prefisso (+ oppure 00). Utilizza un formato come +49 2 545 8654.',
      reqAtLeastOne: "Deve selezionare almeno un'opzione.",
      number: 'Inserisci un numero valido.',
      reqNumber: 'Deve inserire un numero valido.',
      reqFile: 'Deve selezionare un file da caricare.',
      notVerifiedMail: 'Controlli e confermi di nuovo la Sua E-mail.',
      ccard: 'Il numero di carta inserito non è valido.',
      cvv: 'Si prega di inserire un numero CVV valido. Dovrebbe contenere 3 cifre.',
      cvv34: 'Si prega di inserire un numero CVV valido. Dovrebbe contenere 3 o 4 cifre.',
      onePositive: 'Uno dei campi deve essere un numero positivo',
      birthdate: 'La data di nascita inserita non è valida.',
    },
    notification: {
      success: 'Inviato con successo.',
      error: "Errore durante l'invio.",
      moreInfo: 'Ulteriori informazioni',
    },
    fatalError: {
      title: 'Ops. Si è verificato un errore.',
      message: 'Torna alla pagina iniziale e riprovi.',
      button: 'Torna alla pagina iniziale',
      code: {
        propertyIdMissing: 'Codice di accesso non valido',
        unitOrRateMissing: 'È arrivato/a a questa pagina senza selezionare unità o tariffa.',
        phobsError10001: 'Raggiunto il limite di richieste per il servizio di prenotazione esterna',
        phobsError5008: 'Nessuna disponibilità per l’alloggio selezionato. La preghiamo di riprovare con un altro alloggio.',
        validationError: 'Errore durante la convalida dei dati inseriti. La preghiamo di rivedere i Suoi dati personali e di riprovare.',
      },
    },
    myProfile: {
      title: 'Il mio profilo',
      changeEmailText: 'Per modificare la Sua e-mail, contatti',
      changeEmailCC: 'Servizio Clienti',
      newsletter: 'In qualità di membro del MaiStar Rewards Club, riceverai notizie, offerte speciali e vantaggi esclusivi riservati esclusivamente ai membri del programma MaiStar Rewards Club.',
      requiredFields: 'Questi campi sono obbligatori.',
      dataProtection: '<p>Rispettiamo la Sua privacy e ci impegniamo a proteggere i Suoi dati personali. Raccogliamo diversi tipi di dati personali che La riguardano, in relazione al Suo rapporto con noi e ai servizi che utilizza. In ogni caso, raccogliamo ed elaboriamo i Suoi dati personali per scopi legittimi e su valide basi legali.</p><p>Per maggiori informazioni sulla protezione dei Suoi dati personali, La preghiamo di consultare la nostra <a href="#">Informativa sulla privacy</a>.</p>',
    },
  },
  nl: {
    loading: 'bezig met laden...',
    call: 'Telefoongesprek',
    cancel: 'Annuleren',
    join: 'Meedoen',
    country: 'Land',
    search: 'Zoekopdracht',
    close: 'Sluiten',
    next: 'Volgende',
    previous: 'Vorige',
    select: 'Selecteer',
    eur: '€',
    homepage: 'Home page',
    bookNow: 'Boek nu',
    discoverMore: 'Ontdek meer',
    until: 'tot',
    learnMore: 'Ontdek meer',
    localeSwitch: {
      buttonTitle: 'Schakel van plaats',
      title: 'Voorkeuren',
      description: 'Selecteer de taal en valuta van uw voorkeur',
      selectLanguage: 'Kies een taal',
      selectCurrency: 'Kies een valuta',
      footer: 'Alle prijzen in andere valuta\'s dan euro zijn bang.',
      button: 'Voorkeuren bijwerken',
    },
    accessCode: {
      label: 'Toegangscode',
      placeholder: 'Voer de promocode in',
      confirm: 'Bevestigen',
      remove: 'Verwijderen',
      invalidAccessCode: 'De ingevoerde promocode is niet geldig.',
      validAccessCode: 'De ingevoerde promocode is geldig.',
    },
    bookingModal: {
      property: 'Eigendom',
      hotelsResorts: 'Hotels en resorts',
      campsites: 'Campings',
      date: 'Aankomst en vertrek',
      guests: 'Gasten',
      accessCode: 'Promotiecode',
      howMany: 'Hoeveel gasten blijven er?',
      adults: 'Volwassenen',
      noChildren: 'Kinderen',
      selectAge: 'Kind',
      selectBtn: 'Selecteer',
      updateBtn: 'Zoekopdracht bijwerken',
      closeBtn: 'Sluiten',
      openBtn: 'Openen',
      invalidAccessCode: 'Promocode is niet geldig',
      accessCodeIsVoucher: 'Voer een promotiecode in bij de tweede stap van het boekingsproces',
      children: 'kinderen',
      age: 'Leeftijd kind',
      note: 'De accommodatieprijzen worden per eenheid weergegeven en kunnen veranderen afhankelijk van het aantal personen en aanvullende diensten.',
      specialOffer: 'In de kalender worden alleen de data weergegeven waarop deze speciale aanbieding geldt.',
      datesChanged: 'De datums zijn aangepast volgens beschikbaarheid.',
      accessCodeRemoved: 'De promotiecode is verwijderd omdat deze niet geldig is voor deze accommodatie.',
      guestsAdjusted: 'Aantal gasten aangepast vanwege de beperkingen van de accommodatie.',
      changeDates: 'Datums wijzigen',
      datesUnavailable: 'Geen accommodatie beschikbaar voor de geselecteerde datums',
      datesUnavailableContent: 'Er is helaas geen accommodatie beschikbaar voor de geselecteerde datums {property}. Wilt u de dagen die u gereserveerd heeft, wijzigen naar de eerstvolgende beschikbare datums?: <span>{dates}</span>?',
      datesUnavailableForAccessCode: 'De kortingscode is niet geldig voor uw datums',
      datesUnavailableForAccessCodeContent: 'De kortingscode is helaas niet geldig voor uw datums. Wilt u de dagen die u gereserveerd heeft, wijzigen <span>{dates}</span> zodat u gebruik kunt maken van de kortingscode?',
      unavailable: 'Niet beschikbaar',
      checkoutOnly: 'Alleen uitchecken',
    },
    maiFamilyBanner: {
      description: 'Als lid van MaiFamily kun je kiezen uit een selectie aanbiedingen die uitsluitend voor onze medewerkers beschikbaar zijn.',
    },
    loyaltyBanner: {
      title: 'Met dankbaarheid voor je eerste verblijf',
      button: 'Word lid',
      membershipDiscount: 'ledenkorting',
      becomeMember: 'Word lid',
      description: 'Word lid van de MaiStar Rewards Club en bespaar tot wel 20%. Lid worden is doodeenvoudig door je persoonsgegevens te gebruiken terwijl je je verblijf boekt.',
      alreadyMember: 'Ben je al lid?',
      signIn: 'Inloggen',
      maistarPricesApplied: 'MaiStar-zijn van toepassing',
      applyMaistarPrices: 'MaiStar-prijzen toepassen',
    },
    loyaltySplit: {
      title: 'Welkom bij de MaiStar Rewards Club',
      accessAccount: 'Ga naar je account',
      signInText: 'Log in op je account en profiteer van alle voordelen van het MaiStar Rewards-programma.',
      signIn: 'Inloggen',
      newHere: 'Ben je nieuw hier?',
      joinText: 'Word gratis lid en profiteer van de exclusieve voordelen van het MaiStar Rewards-programma.',
      register: 'Registreer nu',
      accessText: 'Als lid van de MaiStar Rewards Club krijgt u toegang tot:',
      benefits: '<li>Mijn profiel en voorkeuren</li><li>Mijn punten</li><li>Mijn reserveringen</li><li>Mijn bonussen</li><li>Krijg tot 20% korting op reserveringen, spaar punten en maak gebruik van exclusieve prijzen</li>',
    },
    unitDemand: {
      availabilityError: 'De beschikbaarheid kon niet worden bepaald',
      modifySearch: 'Zoekopdracht wijzigen',
      contactText: 'Er is geen eenheid beschikbaar voor de gekozen datum.',
      contactButton: 'Neem contact met ons op',
    },
    authStatus: {
      dashboard: 'Overzicht',
      myBookings: 'Mijn boekingen',
      pointsActivity: 'Geactiveerde punten',
      MaiStarRewards: 'MaiStar Rewards',
      myProfile: 'Mijn profiel',
      openMenu: 'Menu openen',
      closeMenu: 'Menu sluiten',
      login: 'Inloggen',
      logout: 'Uitloggen',
    },
    loyaltyProfile: {
      profileLocales: {
        l1050: 'Kroatisch',
        l1040: 'Italiaans',
        l1033: 'Engels',
        l1031: 'Duits',
        l1060: 'Sloveens',
        l1045: 'Pools',
        l2067: 'Nederlands',
      },
      profileTitle: {
        mr: 'meneer',
        mrs: 'mevrouw',
      },
      identity: 'Identiteit',
      title: 'Titel',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      dob: 'Geboortedatum',
      locale: 'Taal',
      contact: 'Contact',
      email: 'E-mail',
      address: 'Adres',
      postalCode: 'Postcode',
      city: 'Stad',
      phoneNumber: 'Telefoonnummer',
      updateSuccess: 'Je profiel is bijgewerkt.',
      isMaiFamily: 'Ik maak deel uit van de Adris Group.',
      corporateCardNumber: 'Zakelijk kaartnummer',
      companyName: 'Bedrijfsnaam',
      maiFamilyNote: '<p>Werknemers komen niet in aanmerking voor het verdienen of inwisselen van punten in dit loyaliteitsprogramma. Werknemers komen wel in aanmerking voor voordelige tarieven via het MaiFamily-programma nadat ze hun bedrijfsgegevens hebben geregistreerd.</p><p>Om uw bedrijfsnaam of zakelijke kaartnummer bij te werken, kunt u contact opnemen met de klantenservice van Loyalty via <a href="mailto:loyalty@maistra.hr">loyalty@maistra.hr</a>. U ontvangt binnen 48 uur een reactie.</p>',
    },
    formValidation: {
      required: 'Dit veld is verplicht.',
      email: '<span>Voer een geldig e-mailadres in. Gebruik het formaat zoals naam&#64;voorbeeld.com.</span>',
      min: 'Dit veld moet minimaal hebben',
      maxPoints: 'Het geselecteerde aantal is niet beschikbaar.',
      eq: 'Dit veld moet hebben',
      digits: 'cijfers',
      characters: 'tekens',
      size: 'Maximale bestandsgrootte is',
      phone: 'Voer een geldig telefoonnummer in met een landennummer (+ of 00). Gebruik het formaat als +49 2 545 8654.',
      reqAtLeastOne: 'Je moet minimaal één optie selecteren.',
      number: 'Voer een geldig nummer in.',
      reqNumber: 'Je moet een geldig nummer invoeren.',
      reqFile: 'Je moet een bestand selecteren om te uploaden.',
      notVerifiedMail: 'Controleer je e-mail opnieuw.',
      ccard: 'Het door jou ingevoerde kaartnummer is ongeldig.',
      cvv: 'Voer een geldig CVV-nummer in. Dat moeten 3 cijfers zijn.',
      cvv34: 'Voer een geldig CVV-nummer in. Dat moeten 3 of 4 cijfers zijn.',
      onePositive: 'Een van de velden moet een positief getal zijn',
      birthdate: 'De ingevoerde geboortedatum is niet geldig.',
    },
    notification: {
      success: 'Succesvol verzonden.',
      error: 'Fout tijdens het verzenden.',
      moreInfo: 'Meer informatie',
    },
    fatalError: {
      title: 'Oeps. Er is een fout opgetreden!',
      message: 'Keer terug naar de startpagina en probeer het opnieuw.',
      button: 'Terug naar de startpagina',
      code: {
        propertyIdMissing: 'Je bent op deze pagina terechtgekomen zonder een accommodatie te selecteren',
        unitOrRateMissing: 'Je bent op deze pagina terechtgekomen zonder een eenheid of tarief te selecteren.',
        phobsError10001: 'Verzoeklimiet voor externe boekingsservice bereikt',
        phobsError5008: 'Er is geen beschikbaarheid voor de geselecteerde unit. Probeer het opnieuw met een andere unit.',
        validationError: 'Fout bij het valideren van uw ingevoerde gegevens. Controleer uw persoonlijke gegevens en probeer het opnieuw.',
      },
    },
    myProfile: {
      title: 'Mijn profiel',
      changeEmailText: 'Om je e-mailadres te wijzigen, neem contact op met:',
      changeEmailCC: 'Klantenservice',
      newsletter: 'Als lid van de MaiStar Rewards Club ontvangt u nieuws, speciale aanbiedingen en exclusieve voordelen die uitsluitend zijn voorbehouden aan leden van het MaiStar Rewards Club-programma.',
      requiredFields: 'Deze velden zijn verplicht.',
      dataProtection: '<p>Wij respecteren je privacy en beschermen je persoonsgegevens. Wij verzamelen verschillende soorten persoonlijke gegevens over je, afhankelijk van je relatie tot ons en de diensten die je gebruikt. In ieder geval verzamelen en verwerken wij je gegevens voor gerechtigde doeleinden en op een wettig geldende basis.</p><p>Voor meer informatie over de bescherming van je persoonsgegevens verwijzen wij naar onze <a href="#">Privacyverklaring</a>.</p>',
    },
  },
  pl: {
    loading: '', // just a placeholder for empty
    call: 'Połączenie',
    cancel: 'Anuluj',
    join: 'Dołącz',
    country: 'Kraj',
    search: 'Szukaj',
    close: 'Zamknij',
    next: 'Następny',
    previous: 'Poprzedni',
    select: 'Wybierz',
    eur: '€',
    homepage: 'Home page',
    bookNow: 'Zarezerwuj teraz',
    discoverMore: 'Odkryj więcej',
    until: 'do',
    learnMore: 'Dowiedz się więcej',
    localeSwitch: {
      buttonTitle: 'Połącz regionę',
      title: 'Preferencje',
      description: 'Wybierz preferowany język i walutę',
      selectLanguage: 'Wybierz język',
      selectCurrency: 'Wybierz walutę',
      footer: 'Ceny wyrażone we wszystkich walutach poza euro są orientacyjne.',
      button: 'Zaktualizuj preferencje',
    },
    accessCode: {
      label: 'Kod promocyjny',
      placeholder: 'Wpisz kod promocyjny',
      confirm: 'Potwierdź',
      remove: 'Usuń',
      invalidAccessCode: 'Wprowadzony kod promocyjny jest nie aktualny.',
      validAccessCode: 'Wprowadzony kod promocyjny jest ważny.',
    },
    bookingModal: {
      property: 'Obiekt',
      hotelsResorts: 'Hotele i ośrodki',
      campsites: 'Kempingi',
      date: 'Przyjazd & odjazd',
      guests: 'Goście',
      accessCode: 'Kod promocyjny',
      howMany: 'Ilu gości będzie przebywać?',
      adults: 'Dorośli',
      noChildren: 'Dzieci',
      selectAge: 'Dziecko',
      selectBtn: 'Wybierz',
      updateBtn: 'Zaktualizuj wyszukiwanie',
      closeBtn: 'Zamknij',
      openBtn: 'Otwórz',
      invalidAccessCode: 'Kod promocyjny jest nie aktualny.',
      accessCodeIsVoucher: 'Proszę wpisać kod promocyjny w drugim kroku procesu rezerwacji',
      children: 'dzieci',
      age: 'Wiek dziecka',
      note: 'Ceny zakwaterowania podane są za jednostkę i mogą ulec zmianie, w zależności od liczby osób i dodatkowych usług.',
      specialOffer: 'W kalendarzu wyświetlane są tylko daty dostępne dla oferty specjalnej.',
      datesChanged: 'Daty zmieniły się w zależności od dostępności.',
      accessCodeRemoved: 'Kod promocyjny został usunięty, ponieważ nie jest ważny dla tej usługi.',
      guestsAdjusted: 'Liczba gości dostosowana do limitu nieruchomości.',
      changeDates: 'Zmień daty',
      datesUnavailable: 'Brak dostępnego zakwaterowania w wybranym terminie',
      datesUnavailableContent: 'Niestety, brak dostępnego zakwaterowania w wybranym terminie {property}. Czy chcesz zmienić datę swojej rezerwacji na najbliższy dostępny termin: <span>{dates}</span>?',
      datesUnavailableForAccessCode: 'Kod promocyjny nie może zostać wykorzystany na podane daty',
      datesUnavailableForAccessCodeContent: 'Niestety, kod promocyjny nie może zostać wykorzystany w wybranych datach. Czy chcesz zmienić datę Twojej rezerwacji, <span>{dates}</span> tak byś mógł skorzystać z kodu promocyjnego?',
      unavailable: 'Niedostępne',
      checkoutOnly: 'Tylko wymeldowanie',
    },
    maiFamilyBanner: {
      description: 'Jako członek MaiFamily możesz wybierać spośród ofert dostępnych wyłącznie dla naszych pracowników.',
    },
    loyaltyBanner: {
      title: 'Z wdzięcznością, od Twojego pierwszego pobytu',
      button: 'Zostań członkiem',
      membershipDiscount: 'zniżka członkowska',
      becomeMember: 'Zostań członkiem',
      description: 'Zostań członkiem MaiStar Rewards Club i oszczędź nawet do 20%. Możesz łatwo dołączyć, za pomocą swoich danych osobowych, już podczas rezerwacji pobytu.',
      alreadyMember: 'Już jesteś członkiem?',
      signIn: 'Zaloguj się',
      maistarPricesApplied: 'Zastosowano ceny MaiStar',
      applyMaistarPrices: 'Zastosuj ceny MaiStar',
    },
    loyaltySplit: {
      title: 'Witamy w MaiStar Rewards Club',
      accessAccount: 'Dostęp do Twojego konta',
      signInText: 'Zaloguj się na swoje konto i ciesz się wszystkimi korzyściami Programu MaiStar Rewards.',
      signIn: 'Zaloguj się',
      newHere: 'Jesteś tu nowy?',
      joinText: 'Dołącz za darmo i odblokuj wyjątkowe korzyści Programu MaiStar Rewards.',
      register: 'Zarejestruj się teraz',
      accessText: 'Dołączając do MaiStar Rewards Club, zyskasz wgląd w:',
      benefits: '<li>Mój profil i Preferencje</li><li>Moje Punkty</li><li>Moje Rezerwacje</li><li>Moje Nagrody</li><li>Otrzymaj do 20% zniżki na rezerwacje, zbieraj punkty i zyskuj wyjątkowe nagrody</li>',
    },
    unitDemand: {
      availabilityError: 'Nie można określić dostępności',
      modifySearch: 'Zmodyfikuj wyszukiwanie',
      contactText: 'Niestety nie ma dostępnych miejsc w wybranym okresie.',
      contactButton: 'Skontaktuj si�� z nami',
    },
    authStatus: {
      dashboard: 'Przegląd',
      myBookings: 'Moje rezerwacje',
      pointsActivity: 'Aktywne punkty',
      MaiStarRewards: 'Nagrody MaiStar',
      myProfile: 'Mój profil',
      openMenu: 'Otwórz menu',
      closeMenu: 'Zamknij menu',
      login: 'Login',
      logout: 'Wyloguj się',
    },
    loyaltyProfile: {
      profileLocales: {
        l1050: 'chorwacki',
        l1040: 'włoski',
        l1033: 'angielski',
        l1031: 'niemiecki',
        l1060: 'słoweński',
        l1045: 'polski',
        l2067: 'niderlandzki',
      },
      profileTitle: {
        mr: 'Pan',
        mrs: 'Pani',
      },
      identity: 'Tożsamość',
      title: 'Tytuł',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      dob: 'Data urodzin',
      locale: 'Język',
      contact: 'Kontakt',
      email: 'Email',
      address: 'Adres',
      postalCode: 'Kod pocztowy',
      city: 'Miasto',
      phoneNumber: 'Numer telefonu',
      updateSuccess: 'Pomyślnie zaktualizowałeś swój profil.',
      isMaiFamily: 'Jestem częścią Grupy Adris.',
      corporateCardNumber: 'Numer karty firmowej',
      companyName: 'Nazwa firmy',
      maiFamilyNote: '<p>Pracownicy nie są uprawnieni do gromadzenia ani wymiany punktów w ramach tego programu lojalnościowego. Zamiast tego pracownicy są uprawnieni do korzystania z preferencyjnych stawek w ramach programu MaiFamily, po zarejestrowaniu danych swojej firmy.</p><p>Aby zaktualizować nazwę firmy lub numer karty korporacyjnej, prosimy o kontakt z działem obsługi klienta programu lojalnościowego pod adresem <a href="mailto:loyalty@maistra.hr">loyalty@maistra.hr</a>. Odpowiedź otrzymasz w ciągu 48 godzin.</p>',
    },
    formValidation: {
      required: 'To pole jest wymagane.',
      email: '<span>Wprowadź prawidłowy adres e-mail. Proszę użyć następującego formatu name&#64;example.com.</span>',
      min: 'To pole musi mieć co najmniej',
      maxPoints: 'Wybrana kwota jest niedostępna.',
      eq: 'To pole musi mieć',
      digits: 'cyfry',
      characters: 'znaków',
      size: 'Maksymalny rozmiar pliku to',
      phone: 'Wprowadź prawidłowy numer telefonu z prefiksem (+ lub 00). Proszę użyć następującego formatu +49 2 545 8654.',
      reqAtLeastOne: 'Musisz wybrać co najmniej jedną opcję.',
      number: 'Wprowadź prawidłowy numer.',
      reqNumber: 'Musisz wpisać poprawny numer.',
      reqFile: 'Musisz wybrać plik do przesłania.',
      notVerifiedMail: 'Sprawdź i ponownie zweryfikuj swój adres e-mail.',
      ccard: 'Wprowadzony numer karty jest nieprawidłowy.',
      cvv: 'Podaj prawidłowy numer CVV. Powinien zawierać 3 cyfry.',
      cvv34: 'Podaj prawidłowy numer CVV. Powinien zawierać 3 lub 4 cyfry.',
      onePositive: 'Jedno z pól musi być liczbą dodatnią',
      birthdate: 'Wprowadzona data urodzenia jest nieprawidłowa.',
    },
    notification: {
      success: 'Pomyślnie przesłano.',
      error: 'Błąd podczas przesyłania.',
      moreInfo: 'Więcej informacji',
    },
    fatalError: {
      title: 'Przepraszamy, ale coś poszło nie tak.',
      message: 'Wróć do strony głównej i spróbuj ponownie.',
      button: 'Wróć do strony głównej',
      code: {
        propertyIdMissing: 'Dotarłeś do tej strony bez wybranego obiektu.',
        unitOrRateMissing: 'Dotarłeś do tej strony bez wybrania jednostki lub stawki.',
        phobsError10001: 'Osiągnięto limit żądań w zewnętrznej usłudze rezerwacji',
        phobsError5008: 'Wybrana jednostka jest niedostępna. Spróbuj ponownie, wybierając inną jednostkę.',
        validationError: 'Błąd podczas sprawdzania poprawności wprowadzonych danych. Sprawdź swoje dane osobowe i spróbuj ponownie.',
      },
    },
    myProfile: {
      title: 'Mój profil',
      changeEmailText: 'W celu zmiany adresu e-mail, prosimy o kontakt',
      changeEmailCC: 'Obsługa klienta',
      newsletter: 'Jako członek programu MaiStar Rewards Club będziesz otrzymywać wiadomości, oferty specjalne oraz ekskluzywne korzyści przeznaczone wyłącznie dla członków programu MaiStar Rewards Club.',
      requiredFields: 'Te pola są wymagane.',
      dataProtection: '<p>Szanujemy Twoją prywatność i jesteśmy zobowiązani do ochrony Twoich danych osobowych. Zbieramy różne rodzaje Twoich danych osobowych, w zależności od Twoich relacji z nami oraz usług, z których korzystasz. Zawsze gromadzimy i przetwarzamy Twoje dane osobowe w uzasadnionych celach i na ważnej podstawie prawnej.</p><p>Aby uzyskać więcej informacji na temat ochrony Twoich danych osobowych, zapoznaj się z naszą <a href="#"> Informacja o ochronie prywatności</a>.</p>',
    },
  },
  si: {
    loading: '', // samo označba mesta za prazno polje
    call: 'Klic',
    cancel: 'Prekliči',
    join: 'Pridruži se',
    country: 'Država',
    search: 'Išči',
    close: 'Zapri',
    next: 'Naslednji',
    previous: 'Prejšnji',
    select: 'Izberi',
    eur: '€',
    homepage: 'Home page',
    bookNow: 'Rezervirajte zdaj',
    discoverMore: 'Odkrijte več',
    until: 'do',
    learnMore: 'Odkrijte več',
    localeSwitch: {
      buttonTitle: 'Nastavitve jezika',
      title: 'Nastavitve',
      description: 'Izberite želen jezik in valuto.',
      selectLanguage: 'Izberite jezik',
      selectCurrency: 'Izberite valuto',
      footer: 'Cene, izražene v vseh valutah z izjemo evra, so okvirne.',
      button: 'Posodobi nastavitve',
    },
    accessCode: {
      label: 'Promocijska koda',
      placeholder: 'Vpišite promocijsko kodo',
      confirm: 'Potrdi',
      remove: 'Odstrani',
      invalidAccessCode: 'Vpisana promocijska koda ni veljavna.',
      validAccessCode: 'Vpisana promocijska koda je veljavna.',
    },
    bookingModal: {
      property: 'Objekt',
      hotelsResorts: 'Hoteli in letovišča',
      campsites: 'Kampi',
      date: 'Prihod in odhod',
      guests: 'Gostje',
      accessCode: 'Promocijska koda',
      howMany: 'Koliko gostov bo bivalo?',
      adults: 'Odrasli',
      noChildren: 'Otroci',
      selectAge: 'Otrok',
      selectBtn: 'Izberi',
      updateBtn: 'Posodobi iskanje',
      closeBtn: 'Zapri',
      openBtn: 'Odpri',
      invalidAccessCode: 'Promocijska koda ni veljavna',
      accessCodeIsVoucher: 'Kodo vavčerja vnesite v 2. koraku rezervacije',
      children: 'otroci',
      age: 'Starost otroka',
      note: 'Cene namestitve so navedene po enoti in se lahko spremenijo glede na število oseb in dodatne storitve.',
      specialOffer: 'Na koledarju so prikazani samo datumi, ki so na voljo za posebno ponudbo.',
      datesChanged: 'Datumi so se spremenili glede na razpoložljivost.',
      accessCodeRemoved: 'Promocijska koda je bila odstranjena, ker ni veljavna za ta objekt.',
      guestsAdjusted: 'Prilagojeno število gostov zaradi omejitev objekta.',
      changeDates: 'Spremeni datume',
      datesUnavailable: 'Za izbrane datume ni razpoložljive namestitve',
      datesUnavailableContent: 'Žal za izbrane datume ni razpoložljive namestitve v {property}. Ali želite spremeniti datume svoje rezervacije na naslednje razpoložljive datume: <span>{dates}</span>?',
      datesUnavailableForAccessCode: 'Promocijska koda ni veljavna za vaše datume',
      datesUnavailableForAccessCodeContent: 'Žal promocijska koda ni veljavna za izbrane datume. Ali želite spremeniti datume svoje rezervacije na <span>{dates}</span>, da boste lahko uporabili promocijsko kodo?«',
      unavailable: 'Ni na voljo',
      checkoutOnly: 'Samo za odjavo',
    },
    maiFamilyBanner: {
      description: 'Kot član MaiFamily lahko izbirate med naborom ponudb, ki so na voljo samo našim zaposlenim.',
    },
    loyaltyBanner: {
      title: 'S hvaležnostjo za vaše prvo bivanje',
      button: 'Postanite član/-ica',
      membershipDiscount: 'popust za člane',
      becomeMember: 'Postanite član/-ica',
      description: 'Postanite član kluba MaiStar Rewards Club in prihranite do 20 %. Klubu se lahko enostavno pridružite, tako da uporabite osebne podatke, ki jih potrebujete za rezervacijo svojega bivanja.',
      alreadyMember: 'Ste že včlanjeni?',
      signIn: 'Prijava',
      maistarPricesApplied: 'Uporabljene so cene MaiStar',
      applyMaistarPrices: 'Uporabi cene MaiStar',
    },
    loyaltySplit: {
      title: 'Dobrodošli v klubu MaiStar Rewards Club',
      accessAccount: 'Dostopajte do svojega računa',
      signInText: 'Vpišite se v svoj račun in uživajte v vseh prednostih programa MaiStar Rewards.',
      signIn: 'Prijava',
      newHere: 'Ste novi tukaj?',
      joinText: 'Pridružite se brezplačno in odklenite ekskluzivne ugodnosti programa MaiStar Rewards.',
      register: 'Registrirajte se zdaj',
      accessText: 'S članstvom v klubu MaiStar Rewards boste imeli vpogled v:',
      benefits: '<li>Moj profil in želje,</li><li>Moje točke,</li><li>Moje rezervacije,</li><li>Moje nagrade.</li><li>Pridobite do 20 % popusta za rezervacije, zbirajte točke in izkoristite ekskluzivne nagrade.</li>',
    },
    unitDemand: {
      availabilityError: 'Razpoložljivosti ni bilo mogoče določiti',
      modifySearch: 'Spremeni iskanje',
      contactText: 'Na žalost ni razpoložljivih enot v izbranem obdobju.',
      contactButton: 'Obrnite se na nas',
    },
    authStatus: {
      dashboard: 'Pregled',
      myBookings: 'Moje rezervacije',
      pointsActivity: 'Aktivirane točke',
      MaiStarRewards: 'Nagrade MaiStar',
      myProfile: 'Moj profil',
      openMenu: 'Odpri meni',
      closeMenu: 'Zapri meni',
      login: 'Prijava',
      logout: 'Odjava',
    },
    loyaltyProfile: {
      profileLocales: {
        l1050: 'Hrvaško',
        l1040: 'Italijansko',
        l1033: 'Angleško',
        l1031: 'Nemško',
        l1060: 'Slovensko',
        l1045: 'Poljsko',
        l2067: 'Nizozemsko',
      },
      profileTitle: {
        mr: 'G.',
        mrs: 'Ga.',
      },
      identity: 'Osebni podatki',
      title: 'Naziv',
      firstName: 'Ime',
      lastName: 'Priimek',
      dob: 'Datum rojstva',
      locale: 'Jezik',
      contact: 'Podatki za stik',
      email: 'E-poštni naslov',
      address: 'Naslov',
      postalCode: 'Poštna številka',
      city: 'Kraj',
      phoneNumber: 'Telefonska številka',
      updateSuccess: 'Uspešno ste posodobili svoj profil.',
      isMaiFamily: 'Sem del skupine Adris.',
      corporateCardNumber: 'Številka kartice podjetja',
      companyName: 'Ime podjetja',
      maiFamilyNote: '<p>Zaposleni niso upravičeni do pridobivanja ali unovčevanja točk v tem programu zvestobe. Namesto tega so zaposleni ob registraciji podatkov o svojem podjetju upravičeni do ugodnejših cen v programu MaiFamily.</p><p>Če želite posodobiti ime podjetja ali številko kartice podjetja, se obrnite na Loyalty Customer Care, ki je na voljo na naslovu <a href="mailto:loyalty@maistra.hr">loyalty@maistra.hr</a>. Odgovor boste prejeli v 48 urah.</p>',
    },
    formValidation: {
      required: 'To polje je obvezno.',
      email: '<span>Vpišite veljaven e-poštni naslov. Uporabite obliko zapisa, kot je name&#64;example.com.</span>',
      min: 'To polje mora vsebovati vsaj',
      maxPoints: 'Izbrani znesek ni na voljo.',
      eq: 'To polje mora vsebovati',
      digits: 'števke',
      characters: 'znaki',
      size: 'Največja velikost datoteke je',
      phone: 'Vpišite veljavno telefonsko številko s predpono (+ ali 00). Uporabite obliko zapisa, kot je +49 2 545 8654.',
      reqAtLeastOne: 'Izbrati morate vsaj eno možnost.',
      number: 'Vpišite veljavno številko.',
      reqNumber: 'Vnesti morate veljavno številko.',
      reqFile: 'Izbrati morate datoteko za prenos.',
      notVerifiedMail: 'Preverite in potrdite svoj e-poštni naslov še enkrat.',
      ccard: 'Vpisana številka kartice ni veljavna.',
      cvv: 'Vpišite veljavno številko CVV, Vsebovati mora 3 števke.',
      cvv34: 'Vpišite veljavno številko CVV, Vsebovati mora 3 ali 4 števke.',
      onePositive: 'Eno od polj mora biti pozitivno število',
      birthdate: 'Vnesen datum rojstva ni pravilen.',
    },
    notification: {
      success: 'Uspešno poslano.',
      error: 'Napaka pri pošiljanju.',
      moreInfo: 'Več informacij',
    },
    fatalError: {
      title: 'Žal nam je, vendar je prišlo je do napake.',
      message: 'Vrnite se na domačo stran in poskusite znova.',
      button: 'Nazaj na domačo stran',
      code: {
        propertyIdMissing: 'Na tej strani ste pristali, ne da bi izbrali objekt.',
        unitOrRateMissing: 'Na to stran ste prispeli, ne da bi izbrali enoto ali ceno.',
        phobsError10001: 'Dosežena omejitev zahtev za zunanjo storitev rezervacij',
        phobsError5008: 'Izbrana enota ni na razpolago. Poskusite znova z drugo enoto.',
        validationError: 'Napaka pri potrjevanju vaših vnesenih podatkov. Preverite svoje osebne podatke in poskusite znova.',
      },
    },
    myProfile: {
      title: 'Moj profil',
      changeEmailText: 'Za spremembo e-poštnega naslova se obrnite na',
      changeEmailCC: 'Služba za pomoč uporabnikom',
      newsletter: 'Kot član programa MaiStar Rewards Club boste prejemali novice, posebne ponudbe in ekskluzivne ugodnosti, namenjene izključno članom programa MaiStar Rewards Club.',
      requiredFields: 'Ta polja so obvezna.',
      dataProtection: '<p>Spoštujemo vašo zasebnost in smo zavezani k zaščiti vaših osebnih podatkov. O vas zbiramo različne vrste osebnih podatkov, kar je odvisno od vašega razmerja z nami in storitev, ki jih uporabljate. V vsakem primeru pa vaše osebne podatke zbiramo in obdelujemo v zakonite namene in v skladu z veljavno pravno podlago.</p><p>Za več informacij o zaščiti vaših osebnih podatkov glejte naše <a href="#">Obvestilo o zasebnosti</a>.</p>',
    },
  },
}

const datetimeFormats = {
  en: {
    month: {
      month: 'long',
    },
  },
  de: {
    month: {
      month: 'long',
    },
  },
  hr: {
    month: {
      month: 'long',
    },
  },
  it: {
    month: {
      month: 'long',
    },
  },
  nl: {
    month: {
      month: 'long',
    },
  },
  pl: {
    month: {
      month: 'long',
    },
  },
  si: {
    month: {
      month: 'long',
    },
  },
}

export {
  messagesCommon,
  datetimeFormats,
}
